<div class="admin-page-button-container">
    <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onClick()">Run</button>
</div>